import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { MsgCampaign } from './msg-campaign';
import { SharedService } from './../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class MsgCampaignService {

	statuses: any = [
		{ value: '1', name: 'Draft' },
		{ value: '2', name: 'Sent' },
		{ value: '3', name: 'Received' },
		{ value: '4', name: 'Failed' },
	];


	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'msgCampaigns';
  add(msgCampaign: MsgCampaign): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(msgCampaign));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, msgCampaign);
	}


	update(msgCampaign: MsgCampaign): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, msgCampaign);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

  sendMessage(msgCampaignId, attachments: any[]): Observable<ApiResponse> {
    let formData = new FormData();
    if ( attachments?.length > 0){
      attachments.forEach(file => {
        formData.append('attachments', file);
      });
    }
    let msgCampaignAPI: MsgCampaign = new MsgCampaign();
    msgCampaignAPI.msgCampaignId = msgCampaignId;
    msgCampaignAPI.attachments = null;
    formData.append('msgCampaignAPI', new Blob([JSON
      .stringify(msgCampaignAPI)], {
      type: 'application/json'
    }));
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/sendMsg`, formData);
  }
	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}
	getMsgStatusCount(msgCampaignId: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/getstatuscount/${msgCampaignId}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	sendutBoxOMsgs(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/msgs/send-outbox-msges`);
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}
	generateMsges(searchForm): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/generateMsgs/`, searchForm);
	}
	generateMsgesCount(searchForm): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/generateMsgsCount/`, searchForm);
	}

	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
